import moment from "moment";
import { fetchQuery } from "relay-runtime";

import { DailyUpdater } from "~/lib/dailyUpdate";
import { LRURetainer } from "~/lib/relayUtil";
import { environment } from "~/models";

import { isViewMode, PAGE_SIZE, meetingsStore as store, VIEW_MODE_KEY } from "./utils";

import ConcreteMeetingsPanelQuery, {
	type MeetingsPanelQuery,
	type MeetingsPanelQuery$variables as MeetingsPanelQueryVariables,
} from "~/__generated__/MeetingsPanelQuery.graphql";

const queryRetainer = new LRURetainer(10);

function updateFunc() {
	const date = new Date();
	const storeViewMode = store.get(VIEW_MODE_KEY, "agenda");
	const viewMode = isViewMode(storeViewMode) ? storeViewMode : "agenda";
	const mdate = moment(date);
	const isDay = viewMode === "day";

	const start = isDay ? moment(mdate).startOf("day") : moment(mdate).subtract(PAGE_SIZE, "day");
	const end = isDay ? moment(mdate).endOf("day") : moment(mdate).add(PAGE_SIZE, "day");

	const variables: MeetingsPanelQueryVariables = {
		start: moment(start).toISOString(),
		end: moment(end).toISOString(),
	};
	fetchQuery<MeetingsPanelQuery>(environment, ConcreteMeetingsPanelQuery, variables, {
		fetchPolicy: "store-or-network",
	}).toPromise();
	queryRetainer.retain(ConcreteMeetingsPanelQuery, variables);
}

const updater = new DailyUpdater(updateFunc);

updater.start();
